import { LinkOutlined, UserOutlined ,HomeOutlined} from '@ant-design/icons';
import type { Settings as LayoutSettings } from '@ant-design/pro-components';
import { SettingDrawer } from '@ant-design/pro-components';
import type { RequestConfig, RunTimeLayoutConfig } from '@umijs/max';
import { history, Link } from '@umijs/max';
import React from 'react';
import {
  AvatarDropdown,
  AvatarName,
  Footer,
  Question,
  SelectLang,
  Logout,
  HomePage,
  ThemeSwitcher
} from '@/components';
import { Button, Tooltip } from 'antd';
import { currentUser as queryCurrentUser } from '@/services/apis/login.api';
import { usermenulist } from './services/apis/system.api';
import defaultSettings from '../config/defaultSettings';
import { errorConfig } from './requestErrorConfig';
import '@ant-design/v5-patch-for-react-19';
import { ConfigProvider } from 'antd';
import { techBlueTheme } from './theme/techTheme';
import {lightTheme} from './theme/lightTheme';
import type { CurrentUser } from '@shenpu/shared-types';
import './app.css';

import { ThemeProvider, useTheme } from '@/context/ThemeContext';
import { themeMap } from '@/theme';


const isDev = process.env.NODE_ENV === 'development';
const loginPath = '/user/login';
const loginPath1 = '/user/login/loginas';
const homepage = '/workportal/yibiaoban'


const AppWithTheme: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { themeName } = useTheme();
  const currentTheme = themeMap[themeName] || themeMap.techBlue;

  return <ConfigProvider theme={currentTheme}>{children}</ConfigProvider>;
};






/**
 * @see https://umijs.org/docs/api/runtime-config#getinitialstate
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: CurrentUser;
  loading?: boolean;
  fetchUserInfo?: () => Promise<CurrentUser | undefined>;
  ///////////////////////////////////////////////////
  accessibleMenuPaths?: string[];

  /////////////////////////////////////////////////////



}> {

  const fetchUserInfo = async () => {
    try {
      const msg = await queryCurrentUser({
        skipErrorHandler: true,
      });
      return msg.data;
    } catch (_error) {
      history.push(loginPath);
    }
    return undefined;
  };
  // 如果不是登录页面，执行
  const { location } = history;

  if (
    ![loginPath,loginPath1, '/user/register', '/user/register-result'].includes(
      location.pathname,
    )
  ) {
    let accessibleMenuPaths: string[] = [];
    const response = await usermenulist();
    if (response?.success && response?.data) {
      accessibleMenuPaths = response.data.map((menu: any) => menu.menud_menupath);
    }
    //debugger;
    //alert(accessibleMenuPaths);
    const currentUser = await fetchUserInfo();
    return {
      fetchUserInfo,
      currentUser,
      settings: defaultSettings as Partial<LayoutSettings>,
      accessibleMenuPaths,
    };
  }
  return {
    fetchUserInfo,
    settings: defaultSettings as Partial<LayoutSettings>,
  };
}

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: RunTimeLayoutConfig = ({
  initialState,
  setInitialState,
}) => {
  return {
    actionsRender: () => [
      <HomePage HomePageUrl={homepage} />,
      <ThemeSwitcher/>,
      <SelectLang key="SelectLang" />,
      <Logout />,
      <Button type="text"><UserOutlined />{`${initialState?.currentUser?.user_name}`}</Button>,
      
    ],
    avatarProps: {
      //src: initialState?.currentUser?.avatar,
      //title: <AvatarName />,
      //render: (_, avatarChildren) => {
      //  return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
      //},
    },
    waterMarkProps: {
      //content: initialState?.currentUser?.user_name,
    },
    footerRender: () => <Footer />,
    onPageChange: () => {
      const { location } = history;
      // 如果没有登录，重定向到 login
      if (!initialState?.currentUser && location.pathname !== loginPath) {
        history.push(loginPath);
      }
    },
    contentStyle: {
      minHeight: 'calc(100vh - 184px)',
    },
    ////////////////////////////////////////////////////////////

    //menuItemRender: (menuItemProps, defaultDom) => {
    //  if (menuItemProps.isUrl || !menuItemProps.path) {
    //    return defaultDom;
    //  }
    //  // 支持二级菜单显示icon
    //  return (
    //    <Link to={menuItemProps.path}>
    //      {menuItemProps.pro_layout_parentKeys
    //        && menuItemProps.pro_layout_parentKeys.length > 0 &&
    //        menuItemProps.icon}{defaultDom}
    //    </Link>
    //  );
    //},
    /////////////////////////////////////////////////////////////
    bgLayoutImgList: [
      {
        src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/D2LWSqNny4sAAAAAAAAAAAAAFl94AQBr',
        left: 85,
        bottom: 100,
        height: '303px',
      },
      {
        src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/C2TWRpJpiC0AAAAAAAAAAAAAFl94AQBr',
        bottom: -68,
        right: -45,
        height: '303px',
      },
      {
        src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/F6vSTbj8KpYAAAAAAAAAAAAAFl94AQBr',
        bottom: 0,
        left: 0,
        width: '331px',
      },
    ],
    //links: isDev
    //  ? [
    //      <Link key="openapi" to="/umi/plugin/openapi" target="_blank">
    //        <LinkOutlined />
    //        <span>OpenAPI 文档</span>
    //      </Link>,
    //    ]
    //  : [],
    menuHeaderRender: undefined,
    // 自定义 403 页面
    // unAccessible: <div>unAccessible</div>,
    // 增加一个 loading 的状态
    childrenRender: (children) => {
      // if (initialState?.loading) return <PageLoading />;
      return (
        <>
        
          {children}
          {isDev && (
            <SettingDrawer
              disableUrlParams
              enableDarkTheme
              settings={initialState?.settings}
              onSettingChange={(settings) => {
                setInitialState((preInitialState) => ({
                  ...preInitialState,
                  settings,
                }));
              }}
            />
          )}
          
        </>
      );
    },
    ...initialState?.settings,
  };
};

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request: RequestConfig = {
  baseURL: process.env.UMI_APP_BACKEND,
  ...errorConfig,
};
export function rootContainer(container: React.ReactNode) {
  return (
    <ThemeProvider>
      <AppWithTheme>{container}</AppWithTheme>
    </ThemeProvider>
  );
}